import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import GetAuthorizationUrlsQuery from './GetAuthorizationUrlsQuery';

export const GetAuthorizationUrlsApolloConnector = ({ children, returnUrl, action }) => {
  const { loading, error, data } = useQuery(GetAuthorizationUrlsQuery, {
    variables: {
      returnUrl: returnUrl,
      state: action,
    },
    fetchPolicy: 'network-only',
  });

  const result = {
    loading,
    error,
  };

  if (!loading) {
    result.facebookUrl = data.auth.authorizationUrl.facebookUrl;
    result.googleUrl = data.auth.authorizationUrl.googleUrl;
    result.appleUrl = data.auth.authorizationUrl.appleUrl;
  }

  return children(result);
};

GetAuthorizationUrlsApolloConnector.propTypes = {
  children: PropTypes.func.isRequired,
  returnUrl: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
};

export default GetAuthorizationUrlsApolloConnector;
